<template>
  <div>
    <div class="content-header">
      <h1>Prehľad objednávok za obdobie - náhľad pred tlačou</h1>
    </div>

    <div class="content">

      <div v-if="invoiceData">
        <div class="row">
          <div class="col-md-12">
            <div class="block">
              <button class="btn btn-primary hidden-print" @click.prevent="print()">Tlač</button>
              <button class="btn btn-default hidden-print" @click.prevent="back()">Zrušiť</button>
            </div>
          </div>
        </div>

        <div class="box">
          <div class="box-header">
            <div>
              <h3 class="visible-print">Prehľad objednávok za obdobie</h3>
              <div class="row">
                <div class="col-xs-12">
                  <dl class="dl-horizontal">
                    <dt>Obdobie:</dt>
                    <dd>{{ invoiceData.dateFrom | date}} - {{ invoiceData.dateTo | date}}</dd>
                    <dt>Odberateľ:</dt>
                    <dd>{{ invoiceData.customer.companyName }}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="row" v-if="invoiceData && !invoiceData.summary.length">
              <div class="col-md-12">
                <alert type="warning">Na vybraný dátum neexistuje žiadna objednávka.</alert>
                <div class="text-center">
                  <button class="btn btn-default hidden-print" @click.prevent="back()">Zrušiť</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="invoiceData.orders.length">
          <section>
            <div class="box">
              <div class="box-header">
                <h3>Rozpis objednávok</h3>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-hover">
                      <thead>
                      <th>Odberateľ</th>
                      <th>Produkt</th>
                      <th>Množstvo</th>
                      <th>Cena bez DPH</th>
                      <th>DPH</th>
                      <th>Spolu bez DPH</th>
                      </thead>
                      <tbody>
                      <tr v-for="order in invoiceData.orders">
                        <td>{{ order.branch.companyName}}</td>
                        <td>{{ order.product.shortDescription }}</td>
                        <td>{{ order.amount }}</td>
                        <td>{{ order.price | currency }}</td>
                        <td>{{ vatRate }} %</td>
                        <td>{{ order.amount * order.price | currency }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </template>

        <template v-if="invoiceData.summary.length">
          <section>
            <div class="box">
              <div class="box-header">
                <h3>Súhrn po položkách</h3>
                <div class="row">
                  <div class="col-xs-12">

                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-hover">
                      <thead>
                      <th>Produkt</th>
                      <th>Množstvo</th>
                      <th>Cena bez DPH</th>
                      <th>DPH</th>
                      <th>Spolu bez DPH</th>
                      </thead>
                      <tbody>
                      <tr v-for="summaryItem in invoiceData.summary">
                        <td>{{ summaryItem.product.shortDescription }}</td>
                        <td>{{ summaryItem.amount }}</td>
                        <td>{{ summaryItem.price | currency }}</td>
                        <td>{{ vatRate }} %</td>
                        <td>{{ summaryItem.amount * summaryItem.price | currency }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </template>
      </div>

      <loading id="invoiceData"></loading>
      <no-records v-if="invoiceData" :data="invoiceData.summary" loadingId="invoiceData"></no-records>
    </div>


  </div>
</template>
<script>
  import {alert} from 'vue-strap';
  import { mapState } from 'vuex';
  import loading from 'components/loading';
  import noRecords from 'components/noRecords';

  export default {
    components: { alert, loading, noRecords },
    computed: {
      ...mapState({
        vatRate: (state) => state.app.configuration.vatRate,
        invoiceData: (state) => state.invoiceData.current
      }),
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      print() {
        window.print();
      },
      fetch() {
        this.$store.dispatch('invoiceData/findCurrent');
      }
    },
    mounted () {
        this.fetch();
    }
  }
</script>



// WEBPACK FOOTER //
// client/views/invoiceDataPrint.vue